var map = {
	"./de/btn-back.png": "V/zy",
	"./en/btn-back.png": "R8uf",
	"./es/btn-back.png": "uqzA",
	"./fr/btn-back.png": "+l2J",
	"./ja/btn-back.png": "uKCc",
	"./ko/btn-back.png": "oNqo",
	"./pt/btn-back.png": "J19x",
	"./ru/btn-back.png": "ZUes",
	"./th/btn-back.png": "O5eb",
	"./zh-Hant/btn-back.png": "5x7y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5Ut";